import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { UtilService } from '@services/util.service';
import { RequisicaoExternaService } from '../../services/requisicaoexterna.service';

@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.css'],
})

export class MapaComponent implements AfterViewInit {
  utilService: UtilService;
  constructor(private requisicaoExternaService: RequisicaoExternaService, @Inject(DOCUMENT) public document: Document) {
  }

  ngAfterViewInit(): void {
    this.functionAtualizarRelatorioTomus();
  }

  functionAtualizarRelatorioTomus = () => {
    this.requisicaoExternaService.ObterResultado("mapa").subscribe(resultado => {
      var referenciaElementoTestado = this.document.getElementById("iframeBaciasMapa") as HTMLIFrameElement;
      var parteToken = resultado.resultadoRequisicao.split(' ');
      referenciaElementoTestado.src = 'https://smsub.tiindustrial.com.br/login?page=monitoring-basin-map&token=' + parteToken[1];
    });
  }

  functionFinishedLoading = (event) => {
    console.log(event);
  }
}
